export enum AppActions {
  // Root Context
  GET_ACTIVE_SERIE = "GET_ACTIVE_SERIE",
  SET_ACTIVE_SERIE = "SET_ACTIVE_SERIE",
  SET_SERIE_MODAL = "SET_SERIE_MODAL",

  // Player Context
  TOGGLE_MOUNT_PLAYER = "MOUNT_PLAYER",
  SET_DURATION = "SET_DURATION",
  TOGGLE_PLAY_VIDEO = "TOGGLE_PLAY_VIDEO",
  TOGGLE_FULLSCREEN = "TOGGLE_FULLSCREEN",
  SET_PROGRESS = "SET_PROGRESS",
  SET_VOLUME = "SET_VOLUME",
  TOGGLE_MUTE = "TOGGLE_MUTE",
  SHOW_PLAYER_VIEW = "SHOW_PLAYER_VIEW"
}
